import BaseObjectStore from './base-object.store';

class SleepReadinessStore extends BaseObjectStore {
  constructor(props) {
    super(props);
    this.name = 'sleepScore';
  }

  resetAllFields() {
    this.resetAllBaseFields();
  }
}

export default new SleepReadinessStore();
